module.exports = __webpack_public_path__ + "/img/QFN-Ct56c8.svg";